import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
import path from 'path'
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */
import siteConfig from '../siteConfig.json'
export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Pro Download APK v18.80 – Anti-Ban Latest Version 2026`,
			keywords: 'GB WhatsApp, GB WhatsApp Pro',
			description: `Download GB WhatsApp Pro APK v18.80 safely for Android phone, PC and windows. Install easily from our trusted source and experience a secure, anti-ban GBWhatsApp app.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/`,
				},
			],
		},
		component: Home,
	},
	{
		path: '/download/',
		name: 'download',
		meta: {
			appname: 'GBWhatsApp',
			title: `Download GB WhatsApp APK File (Latest Version)`,
			keywords: 'Download GB WhatsApp, Download GB WhatsApp APK',
			description: `Download the latest GB WhatsApp APK safely for Android devices. This GBWhatsApp verified 65 MB APK is compatible with Android 5.0 and above, delivering a safe, fast, and seamless experience.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/download/`,
				},
			],
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/gb-whatsapp-for-pc/',
		name: 'gb-whatsapp-for-pc',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp for PC/Windows Download & Install Latest APK Version`,
			keywords: 'GB WhatsApp for PC, GB WhatsApp for Windows, GB WhatsApp APK for PC',
			description: `Download the latest GB WhatsApp APK for PC and Windows and learn how to install and run it safely using an Android emulator.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-for-pc/`,
				},
			],
		},
		component: () => import('@/views/gb-whatsapp-for-pc.vue'),
	},
	{
		path: '/disclaimer/',
		name: 'disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: `Disclaimer – GBWAOnline`,
			keywords: 'GBWAOnline disclaimer, GB WhatsApp disclaimer, WhatsApp MOD disclaimer',
			description: `GBWAOnline does not host or distribute any APK files. We only share details, reviews, features, and guides about apps.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/disclaimer/`,
				},
			],
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	{
		path: '/privacy/',
		name: 'privacy',
		meta: {
			appname: 'GBWhatsApp',
			title: `Privacy Policy – GBWAOnline`,
			keywords: 'GBWAOnline privacy policy, GB WhatsApp privacy, data protection',
			description: `This Privacy Policy document describes the types of information that are collected and recorded by GBWAOnline and how we use it.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/privacy/`,
				},
			],
		},
		component: () => import('@/views/privacy.vue'),
	},
	{
		path: '/about-us/',
		name: 'about-us',
		meta: {
			appname: 'GBWhatsApp',
			title: `About Us – GBWAOnline`,
			keywords: 'GBWAOnline about, GB WhatsApp info, WhatsApp MOD information',
			description: `Visit our site to know about us and our mission. We share GBWhatsApp info and news.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/about-us/`,
				},
			],
		},
		component: () => import('@/views/about-us.vue'),
	},
	{
		path: '/blog/',
		name: 'blog',
		meta: {
			appname: 'GBWhatsApp',
			title: `Latest Blog Posts & Updates — Tutorials, Tips, and Guides`,
			keywords: 'blogs',
			description: `Explore all our latest blog posts, tutorials, and expert guides. Stay updated with new insights, tips, and helpful resources covering a wide range of topics.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/blog/`,
				},
			],
		},
		component: () => import('@/views/blogs.vue'),
	},
	{
		path: '/schedule-messages-in-gbwhatsapp/',
		name: 'schedule-messages-in-gbwhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Schedule Messages in GBWhatsApp?`,
			keywords: 'Schedule Messages in GBWhatsApp',
			description: `This guide explains how to schedule messages in GBWhatsApp with this detailed step-by-step guide. Automate chats, send messages on time, and improve communication efficiency easily.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/schedule-messages-in-gbwhatsapp/`,
				},
			],
		},
		component: () => import('@/views/blog-1.vue'),
	},
	{
		path: '/create-a-gbwhatsapp-theme/',
		name: 'create-a-gbwhatsapp-theme',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Create a GBWhatsApp Theme?`,
			keywords: 'GBWhatsApp theme',
			description: `Learn how to create custom themes in GB WhatsApp by editing backgrounds, fonts, colors, and icons to enhance your app's visual appeal and user experience.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/create-a-gbwhatsapp-theme/`,
				},
			],
		},
		component: () => import('@/views/blog-2.vue'),
	},
	{
		path: '/how-to-hack-gb-whatsapp/',
		name: 'how-to-hack-gb-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Hack GB WhatsApp? Myths, Risks & How to Protect Your Account (2026)`,
			keywords: 'how to hack gb whatsapp, gb whatsapp security, gb whatsapp account safety',
			description: `Wondering if GB WhatsApp can be hacked? Learn the common myths, security risks, and practical ways to protect your GB WhatsApp account in 2026.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/how-to-hack-gb-whatsapp/`,
				},
			],
		},
		component: () => import('@/views/post-hack-gb-whatsapp.vue'),
	},
	{
		path: '/can-whatsapp-gb-see-hidden-status/',
		name: 'can-whatsapp-gb-see-hidden-status',
		meta: {
			appname: 'GBWhatsApp',
			title: `Can Someone With WhatsApp GB See Hidden Status?`,
			keywords: 'can whatsapp gb see hidden status, gb whatsapp status privacy',
			description: `No, WhatsApp GB cannot reliably see a status that you have hidden from them. Learn how WhatsApp status privacy works and what GB features can and cannot do.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/can-whatsapp-gb-see-hidden-status/`,
				},
			],
		},
		component: () => import('@/views/post-hidden-status.vue'),
	},
	{
		path: '/how-to-add-stickers-in-gb-whatsapp/',
		name: 'how-to-add-stickers-in-gb-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Add Stickers in GB WhatsApp ?`,
			keywords: 'how to add stickers in gb whatsapp, gb whatsapp stickers',
			description: `Learn how to add sticker packs in GB WhatsApp, create custom stickers, and fix common sticker issues with this simple guide.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/how-to-add-stickers-in-gb-whatsapp/`,
				},
			],
		},
		component: () => import('@/views/post-add-stickers.vue'),
	},
	{
		path: '/change-gb-whatsapp-home-screen-wallpaper/',
		name: 'change-gb-whatsapp-home-screen-wallpaper',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Change GB WhatsApp Home Screen Wallpaper ?`,
			keywords: 'change gb whatsapp home screen wallpaper, gb whatsapp wallpaper',
			description: `Learn how to change the GB WhatsApp home screen wallpaper using built-in customization features. Step-by-step guide for the latest version.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/change-gb-whatsapp-home-screen-wallpaper/`,
				},
			],
		},
		component: () => import('@/views/post-change-wallpaper.vue'),
	},
	{
		path: '/gb-whatsapp-setup-guide-after-installation/',
		name: 'gb-whatsapp-setup-guide-after-installation',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Setup Guide After Installation (2026) | First Time Settings`,
			keywords: 'gb whatsapp setup, after install guide, whatsapp mod settings',
			description: `Learn how to set up GB WhatsApp after installation. Configure privacy, chats, and basic settings step by step for beginners.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-setup-guide-after-installation/`,
				},
			],
		},
		component: () => import('@/views/guides/guide-setup-after-install.vue'),
	},
	{
		path: '/gb-whatsapp-verification-code-not-working-fix/',
		name: 'gb-whatsapp-verification-code-not-working-fix',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Verification Code Not Working Fix (SMS Issue Solution 2026)`,
			keywords: 'gb whatsapp verification error, sms not received fix',
			description: `Fix GB WhatsApp verification code not received or not working issues with simple step-by-step solutions.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-verification-code-not-working-fix/`,
				},
			],
		},
		component: () => import('@/views/guides/guide-verification-code.vue'),
	},
	{
		path: '/switch-from-official-whatsapp-to-gb-whatsapp/',
		name: 'switch-from-official-whatsapp-to-gb-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `Switch From Official WhatsApp to GB WhatsApp Safely (2026 Guide)`,
			keywords: 'switch whatsapp to gb whatsapp, migrate chats',
			description: `Learn how to switch from official WhatsApp to GB WhatsApp without losing chats or data.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/switch-from-official-whatsapp-to-gb-whatsapp/`,
				},
			],
		},
		component: () => import('@/views/guides/guide-switch-from-official.vue'),
	},
	{
		path: '/gb-whatsapp-chat-privacy-hidden-controls/',
		name: 'gb-whatsapp-chat-privacy-hidden-controls',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Chat Privacy & Hidden Controls Guide (2026 Settings)`,
			keywords: 'gb whatsapp privacy settings, hide online whatsapp mod',
			description: `Learn how to control privacy settings, hide online status, and manage chat visibility in GB WhatsApp.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-chat-privacy-hidden-controls/`,
				},
			],
		},
		component: () => import('@/views/guides/guide-chat-privacy.vue'),
	},
	{
		path: '/gb-whatsapp-media-not-loading-fix/',
		name: 'gb-whatsapp-media-not-loading-fix',
		meta: {
			appname: 'GBWhatsApp',
			title: `Fix GB WhatsApp Media Not Loading or Downloading Issue (2026)`,
			keywords: 'gb whatsapp media not loading, download issue fix',
			description: `Solve GB WhatsApp media not downloading or images not showing problems with simple fixes.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-media-not-loading-fix/`,
				},
			],
		},
		component: () => import('@/views/guides/guide-media-loading.vue'),
	},
	{
		path: '/gb-whatsapp-account-recovery-guide/',
		name: 'gb-whatsapp-account-recovery-guide',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Account Recovery Guide (Restore Suspended Account 2026)`,
			keywords: 'recover gb whatsapp account, restore banned account',
			description: `Step-by-step guide to recover suspended or lost GB WhatsApp accounts safely.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-account-recovery-guide/`,
				},
			],
		},
		component: () => import('@/views/guides/guide-account-recovery.vue'),
	},
	{
		path: '/gb-whatsapp-group-management-guide/',
		name: 'gb-whatsapp-group-management-guide',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Group Management & Admin Tools Guide (2026)`,
			keywords: 'gb whatsapp group admin tools, group settings',
			description: `Learn how to manage groups, use admin tools, and control group settings in GB WhatsApp.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-group-management-guide/`,
				},
			],
		},
		component: () => import('@/views/guides/guide-group-management.vue'),
	},
	{
		path: '/gb-whatsapp-lag-performance-fix/',
		name: 'gb-whatsapp-lag-performance-fix',
		meta: {
			appname: 'GBWhatsApp',
			title: `Fix GB WhatsApp Lag & Performance Issues (Speed Optimization 2026)`,
			keywords: 'gb whatsapp lag fix, performance issue whatsapp mod',
			description: `Improve GB WhatsApp speed, fix lag, crashes, and performance issues on Android devices.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-lag-performance-fix/`,
				},
			],
		},
		component: () => import('@/views/guides/guide-lag-performance.vue'),
	},
	{
		path: '/gb-whatsapp-storage-full-fix/',
		name: 'gb-whatsapp-storage-full-fix',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Storage Full Fix Guide (Clear Cache & Free Space 2026)`,
			keywords: 'gb whatsapp storage full, clear cache fix',
			description: `Fix storage full problems in GB WhatsApp and learn how to clear cache and free space safely.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-storage-full-fix/`,
				},
			],
		},
		component: () => import('@/views/guides/guide-storage-full.vue'),
	},
	{
		path: '/gb-whatsapp-advanced-settings-guide/',
		name: 'gb-whatsapp-advanced-settings-guide',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Advanced Settings Guide (Pro Features 2026)`,
			keywords: 'gb whatsapp advanced settings, pro features mod',
			description: `Learn advanced settings and hidden configurations for professional GB WhatsApp users.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/gb-whatsapp-advanced-settings-guide/`,
				},
			],
		},
		component: () => import('@/views/guides/guide-advanced-settings.vue'),
	},
]

let routes = []

routes = constRoutesPc
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
